RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const MetricDisplay = RivalIQ.apps.Dashboard.widgets.table.MetricDisplay.extend({
        loadData: function (cb) {
            const me = this;

            const metric = me.getOption('metric');
            const post = me.getOption('post');
            const childMetrics = metric.getChildMetrics(me.options);
            me.collection = wrapMetricsFromCollection(post, childMetrics, function (model) {
                return (_.result(model.attributes, ['selectable']) !== false);
            });

            cb();
        }
    });

    views.InstagramMediaObject = RivalIQ.views.LayoutView.mixin({
        template: '#insightsMediaObjectViewTemplate',
        className: 'container-fluid',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            metricsRegion: '.metrics-region',
            postTagPills: '.post-tag-pills'
        },

        ui: {
            popover: `[data-toggle='popover']`
        },

        initialize: function () {
            const me = this;
            me.metric = me.getOption('metric');
        },

        serializeData: function () {
            const me = this;
            const post = me.model;

            const messageWithParagraphs = _.map((post.get('caption') || '').split(/\n+/), function (para) {
                return $.tagHtml('p', {
                    text: para
                });
            }).join('\n');

            const timezone = me.metric.get('timezone');

            const publishedAt = post.get('published_at');
            const dateInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, publishedAt);

            const capturedAt = post.get('captured_at');
            const capturedAtInTz = RivalIQ.utils.timezone.getDateInTimezone(timezone, capturedAt);

            const data = post.toJSON();

            let videoSrc = null;
            if (App.widgets.media.utils.useLinkedInMp4(data)) {
                videoSrc = data.media_url;
            }

            let canonicalUrl = null;
            let metadataTitle = null;
            if (data.source === RivalIQ.enums.sources.TWITTER_INSIGHTS && data.media_type === 'Link') {
                canonicalUrl = _.get(post, ['attributes', 'rivaliq', 'derived', 'canonicalUrl']);
                metadataTitle = _.get(post, [
                    'attributes',
                    'rivaliq',
                    'derived',
                    'metadata',
                    'html',
                    'title'
                ]);
            }

            data.image ||= data.platformImageUrl;

            return _.extend({
                image: null,
                videoSrc: videoSrc
            }, data, {
                useCdnThumbnail: _.get(data, 'useCdnThumbnail', false),
                message: messageWithParagraphs,
                companyLink: `/company/${post.get('company_id')}`,
                dateStr: dateInTz.format('MMM D, YYYY'),
                timeStr: dateInTz.format('LT'),
                capturedAtStr: capturedAtInTz.format('MMM D, YYYY LT'),
                paid_spend: post.get('paid_spend') || null,
                tz: RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, publishedAt),
                channelName: _.upperFirst(RivalIQ.enums.sourceDetails[data.source].channel),
                isFocusCompany: RivalIQ.state.utils.isFocusedCompany(data.company_id),
                canonicalUrl: canonicalUrl || null,
                metadataTitle: metadataTitle || null,
                maxLinkTitleLength: 60
            });
        },

        templateHelpers: function () {
            const me = this;
            const postSource = me.model.get('source');
            return _.extend({
                s: s,
                channel: RivalIQ.data.channels.get(postSource)
            }, App.utils.currencyTemplateHelpers(me.dashboardModel), RivalIQ.utils.emoji.getTemplateHelpers());
        },

        getPostHelperData: function () {
            const me = this;
            return me.model.attributes;
        },

        onRender: function () {
            const me = this;

            me.metricsRegion.show(new MetricDisplay({
                includePaidEngagement: me.includePaidEngagement(),
                metric: me.metric,
                mediaType: me.model.get('media_type'),
                post: me.model,
                enableUpsell: false
            }));

            if (me.getProp('showPostTags')) {
                me.postTagPills.show(new RivalIQ.apps.SocialPosts.views.PostTagPills({
                    post: me.model,
                    postTagsById: _.get(me, ['options', 'postTagsById']) || {},
                    parentDashboardModel: me.dashboardModel,
                    postTagsClickable: false,
                    showActionBtns: false
                }));
            }
            me.ui.popover.popover({
                html: true
            });
        },

        includePaidEngagement: function () {
            const me = this;
            return App.utils.hasInstagramPaidEngagement(me.dashboardModel);
        }
    });

    /** what follows are overrides to support modal metric names (#20289) **/

    function getMetricName(model, options) {
        const modalName = RivalIQ.models.metrics.getProperty(model, 'modalName');
        if (modalName) {
            return modalName;
        }
        return RivalIQ.models.metrics.SocialPost.getName.call(model, options);
    }

    const _get = RivalIQ.models.MetricDefinition.prototype.get;
    function get(model, property) {
        if (property !== 'submetrics') {
            return _get.apply(model, _.tail(arguments));
        }

        const submetrics = _get.call(model, 'submetrics');
        if (submetrics) {

            submetrics.each(m => {
                m.data = model.data;
            });

            return wrapMetricsFromCollection(null, submetrics);
        }
    }

    function wrapMetricsFromCollection(post, collection, fn) {
        const metrics = collection.reduce(function (memo, model) {
            if (!fn || fn(model)) {
                const clone = model.clone();
                memo.push(_.extend(clone, {
                    data: model.data || (post && post.attributes),
                    get: _.partial(get, clone),
                    getName: _.partial(getMetricName, clone)
                }));
            }
            return memo;
        }, []);

        return new RivalIQ.collections.MetricDefinitions(metrics);
    }

    /** this is the end of overrides **/
}, window.s);
